export default __webpack_public_path__ + "static/media/beauty-2.f6c56c49.png";